import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getBeefManureStorageTypes, getBeefManureStorageTypesAdmin } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE, GET_BEEF_MANURE_STORAGE_TYPES } from "consts";

import { BeefManureStorageType } from "models";

export const useGetBeefManureStorageTypes = () => {
  const { t } = useTranslation("beef", { useSuspense: false });
  const isAdmin = getEnvironment().admin;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((storageTypes: BeefManureStorageType[]) => injectNames(storageTypes, t, "storageTypes"), [t]);

  return useQuery({
    queryKey: [GET_BEEF_MANURE_STORAGE_TYPES, isAdmin],
    queryFn: () => (isAdmin ? getBeefManureStorageTypesAdmin() : getBeefManureStorageTypes()),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE.gcTime,
    staleTime: DEFAULT_CACHE.staleTime,
  });
};
